// Module Imports
import { resourceLabels } from '@/modules/role/role.constants'
import type { TPermission, TPermissionGroup } from '@/modules/role/role.types'

export const groupPermissions = (
  permissions: TPermission[]
): TPermissionGroup[] => {
  const groups: TPermissionGroup[] = []

  for (const permission of permissions) {
    const prefix = permission.name.split('.')[0] ?? permission.name

    const existingGroup = groups.find((group) => group.key === prefix)

    if (existingGroup) {
      existingGroup.permissions.push(permission)
    } else {
      groups.push({
        key: prefix,
        label: resourceLabels[prefix] ?? prefix,
        permissions: [permission],
      })
    }
  }

  return groups
}

const permissionAliases: Record<string, string> = {
  'user_roles.list': 'user-roles.list',
  'user_roles.detail': 'user-roles.detail',
  'user_roles.create': 'user-roles.create',
  'user_roles.edit': 'user-roles.edit',
  'user_roles.assign': 'users.roles.assign',
  'users.roles.update': 'users.roles.assign',
}

/**
 * Normalize a backend permission name. Trims whitespace and applies known
 * legacy aliases (e.g. `user_roles.list` → `user-roles.list`). Returns null
 * only on non-string or empty input; unknown names pass through unchanged so
 * the frontend doesn't have to ship every new backend permission.
 */
export const normalizePermissionKey = (name: unknown): string | null => {
  if (typeof name !== 'string') return null
  const trimmedName = name.trim()
  if (!trimmedName) return null
  return permissionAliases[trimmedName] ?? trimmedName
}
